// import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AccountLayout from "../../blocs/AccountLayout";
import { useNavigate, useParams } from "react-router-dom";
import {
  demandeRemboursement,
  fetchRendezvousById,
  selectCurrentRdv,
} from "../../store/slices/rendezVousSlice";
import { useEffect } from "react";
import { formatDate } from "../../utils/utils";
import { toast } from "react-toastify";
import { Helmet, HelmetProvider } from "react-helmet-async";

const DemandeRemboursement = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.user);
  const { idRdv } = useParams();
  const currentRdv = useSelector(selectCurrentRdv);
  const initialValues = { motif: "" };
  const navigate = useNavigate();
  const validationSchema = Yup.object({
    motif: Yup.string()
      .max(1000, "Le motif ne peut pas dépasser 1000 caractères")
      .required("Le motif est obligatoire"),
  });

  useEffect(() => {
    if (idRdv) {
      dispatch(fetchRendezvousById(idRdv));
    }
  }, [dispatch, idRdv]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const remboursement = {
        appointment_id: idRdv,
        motif: values?.motif,
      };
      await dispatch(demandeRemboursement(remboursement)).unwrap();
      toast.success("Demande de remboursement envoyée avec succès");
      setSubmitting(false);
      navigate("/compte/rendez-vous"); // Redirect after success
    } catch (error) {
      // console.error("Erreur lors de l'envoi de la demande :", error);
      toast.error(
        error.message ||
          "Une erreur est survenue lors de l'envoi de la demande de remboursement."
      );
      setSubmitting(false);
    }
  };
  return (
    <AccountLayout bgColor={"bgColor"}>
      <HelmetProvider>
        <Helmet>
          <title>Demande remboursement </title>
          <meta name="description" content=" Page Demande remboursement" />
        </Helmet>
      </HelmetProvider>
      <h3 className="pd-bt-8">Demande de Remboursement</h3>
      {currentRdv?.prestations_snapshot?.map((prestation, index) => (
        <h4 key={index}>{prestation?.name}</h4>
      ))}

      <div className="pdg-24">
        <div className="body bold500 pd-bt-4">
          {currentRdv?.etablissement?.nom}
        </div>
        <span className="body grey66">
          {currentRdv?.etablissement?.activite?.name}
        </span>
        <img
          className="separator"
          src="/images/separateur.svg"
          alt="separateur"
        />
        <span className="body grey66">
          {formatDate(currentRdv?.start_time)}
        </span>
      </div>
      <div className="body bold500 pd-bt-24">
        Montant du remboursement : {currentRdv?.total_ttc}€
      </div>
      <div className="body grey66 pd-bt-8">Motif*</div>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, isSubmitting }) => (
          <Form>
            <div className="row textarea-container">
              <div className="col-12">
                <Field
                  as="textarea"
                  id="motif"
                  name="motif"
                  className="form-control fildtextarea"
                  placeholder="Motif de la demande"
                  rows="10"
                  maxLength="1000"
                />
                <ErrorMessage
                  name="motif"
                  component="div"
                  className="text-danger"
                />
                <span className="textarea-counter">
                  {values.motif.length}/1000
                </span>
              </div>
            </div>
            <div className="body grey66 paddingTop-8 pd-bt-28">
              Attention, vous ne pouvez pas demander de remboursement dans le
              cas d’une annulation de rdv moins de 48h à l’avance. Un doute ?
              Consultez notre
              <a href="/frais" className="text-decoration-none">
                {" "}
                Politique de remboursement
              </a>
            </div>
            <button
              className="twyny-cta-primary mt-4"
              type="submit"
              disabled={isSubmitting || loading}
            >
              {loading ? "Enregistrement..." : "Demander le remboursement"}
            </button>
          </Form>
        )}
      </Formik>
    </AccountLayout>
  );
};

export default DemandeRemboursement;
